export const ApiRequestHeaderConstants = {
    X_XSRF_TOKEN: 'X-XSRF-TOKEN'
}